export { default as R0 } from "./week7.json";